<template>
    <div>
        <div class="setting-panel">
            <div>
                <div class="text-xs font-bold mb-2">Шрифт</div>
                <div class="relative border">
                    <button
                        @click="showFonts = !showFonts"
                        class="text-setting-button flex py-1 px-2 items-center justify-between gap-1"
                    >
                        <span>{{
                            (selectedFont && selectedFont.name) || "Шрифт"
                        }}</span>
                        <span><i class="fa fa-angle-down"></i></span>
                    </button>
                    <ul
                        class="text-setting-dropdown fonts-list absolute bg-white shadow-md pt-4 pb-2 px-4 left-0 h-36 overflow-y-auto rounded"
                        :class="{ open: showFonts }"
                        v-if="showFonts"
                    >
                        <li v-for="font in fonts" :key="`font-${font.font_id}`">
                            <button
                                class="text-left pb-1 cursor-pointer w-full text-gray-600 hover:text-gray-900"
                                @click="selectFont(font)"
                            >
                                {{ font.name }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="text-xs font-bold mb-2">Выравнивание</div>
                <div class="relative border">
                    <button
                        @click="showAligns = !showAligns"
                        class="text-setting-button flex py-1 px-2 items-center justify-between gap-1"
                    >
                        <span class="text-sm">{{
                            (selectedAlign && selectedAlign.name) ||
                            aligns[0].name
                        }}</span>
                        <span><i class="fa fa-angle-down"></i></span>
                    </button>
                    <ul
                        class="text-setting-dropdown fonts-list absolute bg-white shadow-md pt-4 pb-2 px-4 right-0 rounded h-28 overflow-y-auto"
                        :class="{ open: showAligns }"
                        v-if="showAligns"
                    >
                        <li v-for="align in aligns" :key="`align-${align.id}`">
                            <button
                                class="text-left text-sm pb-1 cursor-pointer w-full text-gray-600 hover:text-gray-900"
                                @click="selectAlign(align)"
                            >
                                {{ align.name }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="text-xs font-bold mb-2">Размер, см</div>
                <div class="relative border">
                    <button
                        @click="showFontSizes = !showFontSizes"
                        class="text-setting-button flex py-1 px-2 items-center justify-between gap-1"
                    >
                        <span>{{ selectedSize && selectedSize.height }}</span>
                        <span><i class="fa fa-angle-down"></i></span>
                    </button>
                    <ul
                        class="text-setting-dropdown fonts-list absolute bg-white shadow-md pt-4 pb-2 px-4 right-0 rounded h-36 overflow-y-auto"
                        :class="{ open: showFontSizes }"
                        v-if="showFontSizes"
                    >
                        <li v-for="size in fontSizes" :key="`size-${size.id}`">
                            <button
                                class="text-left pb-1 cursor-pointer w-full text-gray-600 hover:text-gray-900"
                                @click="selectSize(size)"
                            >
                                {{ size.height }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="text-xs font-bold mb-2">Стоимость, &#8381;</div>
                <div class="total-value">{{ total }}</div>
            </div>
        </div>
        <div class="textarea-panel">
            <textarea
                class="w-full bg-black text-white p-5 text-lg mb-2"
                :style="{
                    fontFamily: selectedFont && selectedFont.name,
                    textAlign: selectedAlign && selectedAlign.id,
                }"
                v-model="text"
            ></textarea>
            <div class="text-right">
                <button class="btn btn-small btn-green" @click="save">
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "EditText",
    props: ["editingText"],
    data() {
        return {
            text: "",
            showFonts: false,
            showAligns: false,
            showFontSizes: false,
            selectedFont: null,
            selectedAlign: null,
            selectedSize: null,
        };
    },
    async created() {
        const fonts = await this.$store.dispatch(
            "clientEngravings/getFonts",
            !parseInt(this.settings.engravingAllFonts) &&
                this.settings.engravingSelectedFonts
        );
    },
    mounted() {
        this.text = this.editingText.text;
        this.selectedFont = this.editingText.font;
        this.selectedAlign = this.editingText.align;
        this.selectedSize = this.editingText.size;
    },
    methods: {
        selectFont(font) {
            this.selectedFont = font;
            this.showFonts = false;
        },
        selectAlign(align) {
            this.selectedAlign = align;
            this.showAligns = false;
        },
        selectSize(size) {
            this.selectedSize = size;
            this.showFontSizes = false;
        },
        save() {
            try {
                const setText = {
                    ...this.editingText,
                    total: this.total,
                    text: this.text,
                    align: this.selectedAlign,
                    font: this.selectedFont,
                    size: this.selectedSize,
                };
                this.$store.dispatch("clientOrder/setText", setText);
                this.$emit("text-success-saved");
            } catch (error) {}
        },
    },
    computed: {
        settings() {
            return this.$store.state.settings.settings;
        },
        aligns() {
            // В Vue i18n legacy mode $t() используется для строк,
            // а $tm() — для получения сырых объектов/массивов
            const result = this.$tm("main.aligns");

            // Fallback на hardcoded значения при отсутствии данных в i18n
            if (!result || !Array.isArray(result) || result.length === 0) {
                console.warn(
                    "[EditText] aligns not found in i18n, using fallback"
                );
                return [
                    { id: "left", name: "Слева" },
                    { id: "center", name: "По центру" },
                    { id: "right", name: "Справа" },
                ];
            }

            return result;
        },

        fonts() {
            return this.$store.state.clientEngravings.fonts;
        },

        fontSizes() {
            if (this.settings.fontSizes) {
                return JSON.parse(this.settings.fontSizes);
            }
            return [];
        },
        activeFace() {
            return this.$store.getters["clientOrder/activeFace"];
        },
        total() {
            let total = 0;
            if (this.text && this.editingText && this.selectedSize) {
                total =
                    parseInt(this.text.length) *
                    parseFloat(this.editingText.price) *
                    parseFloat(this.selectedSize.cost_coefficient);
            }
            return total;
        },
    },
    watch: {
        fonts(fonts) {
            if (fonts && fonts.length) {
                let newStyle = document.createElement("style");
                for (const font of fonts) {
                    newStyle.appendChild(
                        document.createTextNode(
                            "\
      @font-face {\
          font-family: '" +
                                font.name +
                                "';\
          src: url('" +
                                font.file +
                                "');\
      }\
      "
                        )
                    );
                }
                document.head.appendChild(newStyle);
            }
        },
    },
};
</script>
<style scoped>
.total-value {
    display: flex;
    height: 34px;
    justify-content: flex-end;
    align-items: center;
}
.setting-panel {
    display: grid;
    margin-bottom: 16px;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
}
.text-setting-button,
.text-setting-dropdown {
    width: 100%;
}
.text-setting-dropdown.open {
    z-index: 10;
}
.textarea-panel {
    display: flex;
    flex-direction: column;
}
.textarea-panel textarea {
    height: 100%;
}

@media screen and (max-width: 1000px) {
    .setting-panel {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
